import { COUPON_COOKIE } from '~/features/cookies/constants';
import { setClientCookie } from '~/features/cookies/utils/set-client-cookie';

export function addCouponCookie(discountCode: string, { expires = 7 }: { expires?: number | Date } = {}) {
  setClientCookie(COUPON_COOKIE, discountCode, expires);
}
